// Participant help / support contacts shown by the floating "Need help?" button
// (src/components/shared/FloatingHelpButton.js).
//
// These values are PUBLIC: they ship in the client bundle, so never put anything
// secret here. Use a dedicated study account/number, not a personal one.
//
// Any channel left blank is hidden; if all are blank the button does not render,
// so it is safe to deploy before these are filled in.
//
//   telegram : username with or without a leading "@" (e.g. "@threatpen" or "threatpen")
//   whatsapp : phone number in international format; spaces/dashes/"+" are ignored
//   email    : support inbox address

const supportContacts = {
  telegram: '@pakkunandy_be',
  whatsapp: '+32 456 63 02 87',
  email: 'anh-duy.tran@kuleuven.be',
};

export default supportContacts;
